export default __webpack_public_path__ + "static/media/100_0000.c58b942a.jpg";